module.exports = __webpack_public_path__ + "static/media/mobioplus_logo.ca6164e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/mobioplus_logo.svg
// module id = 127
// module chunks = 0